<!--
 * @Descripttion: 
 * @version: 
 * @Author: 孙鑫鑫
 * @Date: 2022-03-10 14:29:42
 * @LastEditors: 孙鑫鑫
 * @LastEditTime: 2022-03-10 15:55:37
-->
<template>
  <el-drawer
    title="我是标题"
    :visible="show"
    :direction="'rtl'"
    :withHeader="false"
    custom-class="DrawerUrl"
    size="650px"
  >
    <div class="drawBox">
      <div class="titlebox">
        <div class="title">
          <div class="label">预览</div>
          <div class="close" @click="$emit('close', false)">
            <i class="el-icon-circle-close"></i>
          </div>
        </div>
        <slot name="title"></slot>
      </div>
      <div class="phoneimg">
        <div class="framebox">
          <iframe class="iframe" :src="url" frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: "https://m.topnews.cn/news/1251509",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.DrawerUrl {
  box-shadow: none;
  background-color: transparent !important;
  min-width: 500px !important;
}
</style>
<style lang="scss" scoped>
/deep/ .el-drawer__body {
  background-color: transparent !important;
}
.titlebox {
  width: 60%;
  background: #fff;
  border-radius: 20px;
  margin-bottom: 20px;
  padding: 20px;
  .title {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    .close {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
.drawBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.phoneimg {
  width: 60%;
  height: 70%;
  background-image: url("../../assets/appConfig/download.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 48px 17px 25px;
}
.framebox {
  width: 100%;
  height: 100%;
}
.iframe {
  width: 100%;
  height: 100%;
  border-radius: 30px;
}
</style>
